var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bold / Notifications / Bell "
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.95983 16.8656C7.66073 17.7566 8.76182 18.3307 10 18.3307C11.2382 18.3307 12.3393 17.7566 13.0402 16.8656C11.022 17.1391 8.97798 17.139 6.95983 16.8656Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6243 7.49739V8.08415C15.6243 8.7883 15.8252 9.47671 16.2018 10.0626L17.1247 11.4984C17.9676 12.8098 17.3241 14.5923 15.858 15.007C12.0227 16.0919 7.97728 16.0919 4.14197 15.007C2.67587 14.5923 2.03235 12.8098 2.8753 11.4984L3.79816 10.0626C4.17476 9.47671 4.37573 8.7883 4.37573 8.08415V7.49739C4.37573 4.27573 6.8938 1.66406 10 1.66406C13.1062 1.66406 15.6243 4.27573 15.6243 7.49739Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34625134",
    x: 12,
    width: 6,
    height: 6,
    rx: 3,
    fill: "#E23636"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.272ae6d46c12f018fd7088d44c72a8d7.svg";
export { ForwardRef as ReactComponent };